import NoAccessMessageTikTokExplore from 'components/NoAccessMessage/NoAccessMessageTikTokExplore';
import styled from 'styled-components';

const PaywallInner = styled.div`
    background: white;
    display: flex;
    justify-content: center;
    min-height: 375px;
    align-items: center;
    top: -400px;
    right: 1px;
    left: 1px;
    background: linear-gradient(0deg, white, white, rgba(255, 255, 255, 0));
`;

function TikTokProPaywall({ overlay = true }) {
    return (
        <div css={overlay && `position: relative;`}>
            <PaywallInner css={overlay && `position: absolute;`}>
                <NoAccessMessageTikTokExplore />
            </PaywallInner>
        </div>
    );
}

export default TikTokProPaywall;
